import z from 'zod';
import { deployParamSchema } from '@redviking/argonaut-util/src/mes/deployParam.zod';
import { DeployParamKind } from '@redviking/argonaut-util/src/mes/deployParamKind';

const assetSchemaBase = z.object({
    id: z.string().uuid(),
});

/** this is a reference to a deployment param, not the value */
export const assetDeployParamSchema = deployParamSchema(z.object({
    deployParamId: z.string(),
    deployParamKind: z.literal(DeployParamKind.asset),
}));

/** this is a reference to a deployment param, not the value */
export const assetSchema = z.union([ assetDeployParamSchema, assetSchemaBase.strict() ]);
